import { useState } from 'react';
import { LogIn, Loader2, X } from 'lucide-react';

/**
 * Модальное окно входа (ЧТЗ-AUTH-004, FR-AUTH-16).
 * email + password → POST /auth/login (через useAuth.login).
 *
 * props:
 *   onLogin(email, password) — async, бросает Error с .code при ошибке
 *   onClose()                — закрыть оверлей
 *   onSwitchMode(mode)       — переключить режим модалки ('register' | 'forgot')
 */
const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Неверный email или пароль.',
  EMAIL_NOT_VERIFIED: 'Email не подтверждён, проверьте почту со ссылкой активации.',
  ACCOUNT_INACTIVE: 'Аккаунт неактивен.',
  VALIDATION_ERROR: 'Проверьте корректность введённых данных.',
  SERVICE_UNAVAILABLE: 'Сервис недоступен, попробуйте позже.',
  LOGIN_FAILED: 'Не удалось войти. Попробуйте позже.',
};

export default function LoginModal({ onLogin, onClose, onSwitchMode }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      await onLogin(email, password);
    } catch (err) {
      const code = err?.code || 'LOGIN_FAILED';
      setError(ERROR_MESSAGES[code] || ERROR_MESSAGES.LOGIN_FAILED);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="acc-modal" role="dialog" aria-modal="true" aria-label="Вход">
      <div className="acc-modal-head">
        <h2><LogIn size={16} /> Вход в CatRUS</h2>
        <button className="acc-icon-btn" onClick={onClose} aria-label="Закрыть">
          <X size={16} />
        </button>
      </div>

      <form className="acc-form" onSubmit={handleSubmit}>
        <div className="acc-field">
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </div>

        <div className="acc-field">
          <label htmlFor="login-password">Пароль</label>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
        </div>

        {error && <div className="acc-error" role="alert">{error}</div>}

        <button className="acc-btn-primary" type="submit" disabled={busy}>
          {busy ? <Loader2 size={14} className="spin" /> : <LogIn size={14} />}
          {busy ? 'Вход…' : 'Войти'}
        </button>

        <div className="acc-links">
          <button type="button" className="acc-link" onClick={() => onSwitchMode?.('forgot')}>
            Забыли пароль?
          </button>
          <button type="button" className="acc-link" onClick={() => onSwitchMode?.('register')}>
            Регистрация
          </button>
        </div>
      </form>
    </div>
  );
}
